import { IconButton } from '@repo/foundations';
import { observer } from 'mobx-react-lite';
import { SentimentType } from '../../../components/AIAssistant/AIFeedbackModal/constants';
import type { AiChatStore } from '../store';

export const NegativeFeedbackButton = observer(
	({ id, store }: { id: string; store: AiChatStore }) => {
		const message = store.getMessage(id);

		if (
			message?.prompt.user_feedback_raw?.sentiment === SentimentType.Negative
		) {
			return (
				<IconButton
					iconName="thumbDownFilled"
					variant="tertiary"
					tooltip="Negative feedback for this prompt already submitted"
				/>
			);
		}

		return (
			<IconButton
				iconName="thumbDown"
				variant="tertiary"
				onClick={() => store.showNegativeFeedbackModal(id)}
				tooltip="Bad response"
			/>
		);
	}
);
